// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    ...attributes
  ><g fill='none'><circle
        cx='10'
        cy='10'
        r='10'
        fill='var(--icon-background-color, red)'
      /><path
        fill='var(--icon-color, #FFF)'
        d='M11.143 10.757h-2.32l-.486-6.855h3.29zM8.3 14.01a1.6 1.6 0 0 1 .427-1.207 1.74 1.74 0 0 1 1.246-.41 1.7 1.7 0 0 1 1.222.419c.304.322.461.756.432 1.198a1.6 1.6 0 0 1-.437 1.182c-.33.303-.77.46-1.217.433a1.7 1.7 0 0 1-1.237-.423A1.58 1.58 0 0 1 8.3 14.01'
      /></g></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'FailureBordered';
export default IconComponent;
